import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { withLocalize } from 'react-localize-redux';
import PropTypes from 'prop-types';
import languages from '../utils/languages'; // Note: when importing this file, .babelrc of the dashboard will be used due to babelrc lookup.
import initLocalize from '../utils/initLocalize';
import ImpersonateOrgDialog from '../partnersLandingPage/impersonateOrgDialog';
import Sidenav from '../sidenav/components/sidenav';
import { getIsOrgAdmin, getIsBlocked } from '../selectors/user';
import BlockedOrgPage from './partials/BlockedOrgPage';

function Main({
    initialize = () => {},
    addTranslationForLanguage = () => {},
    setActiveLanguage = () => {},
    sections = [],
    shouldHideSidenav = false,
    children,
}) {
    const isBlocked = useSelector(getIsBlocked);
    const isOrgAdmin = useSelector(getIsOrgAdmin);

    useEffect(() => {
        initLocalize({ initialize, addTranslationForLanguage });
        window.addEventListener('languageChanged', eventData => {
            setActiveLanguage(eventData.detail.code);
            moment.locale(eventData.detail.code);
        });
    }, []);

    return (
        <>
            <Sidenav sections={sections} shouldHideSidenav={shouldHideSidenav}>
                <React.Fragment>
                    {isBlocked && !isOrgAdmin ? <BlockedOrgPage /> : null}
                    {children}
                </React.Fragment>
            </Sidenav>
        </>
    );
}

Main.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
    sections: PropTypes.arrayOf(PropTypes.object),
    initialize: PropTypes.func,
    addTranslationForLanguage: PropTypes.func,
    setActiveLanguage: PropTypes.func,
    shouldHideSidenav: PropTypes.bool,
};

export default withLocalize(Main);
